var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"C-tooltip"},[(_vm.showMessage && _vm.tooltip)?[_c('div',{staticClass:"C-tooltip__content"},[_vm._v(_vm._s(_vm.tooltip.message))]),_vm._v(" "),_c('div',{staticClass:"C-tooltip__arrow"})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }